export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["激活电子支票"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["存款账户"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["数字"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["系列"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["激活码"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["查看"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["启用"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["激活电子支票"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["金额"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["状态"])},
  "status": {
    "issued": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["有效"])},
    "activated": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已激活"])},
    "cancelled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["已取消"])},
    "activating": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["激活中"])},
    "returning": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["退回中"])},
    "prepare": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["待处理"])}
  }
}